import { paramsToQuery } from '@/base/MaUtils.js'
import { makeRequest } from '@/base/MaRequestPooler.js'

export function getSingleAppV2(trackId) {
  return makeRequest(`/account/app/tracked/single/light?${paramsToQuery({ trackId })}`)
}

export function getUserAccountAppCount() {
  return makeRequest('account/app/tracked/count')
}

export function getAppsWithCompetitorsV2(optionalParams) {
  return makeRequest(`/account/app/tracked/competitor/light?${paramsToQuery(optionalParams)}`)
}

export function remove(trackId) {
  return makeRequest(`/account/app/${trackId}`, {
    method: 'DELETE',
  })
}

export function addAppToMyList(trackId, onboarding = false) {
  return makeRequest(`/account/app/${trackId}?${paramsToQuery({ onboarding })}`, {
    method: 'POST',
  })
}

export function addCompetitor(appTrackId, competitorTrackId, onboarding) {
  return makeRequest(`/account/app/${appTrackId}/competitor/${competitorTrackId}?${paramsToQuery({ onboarding })}`, {
    method: 'POST',
    data: {},
  })
}

export function removeCompetitor(appTrackId, competitorTrackId) {
  return makeRequest(`/account/app/${appTrackId}/competitor/${competitorTrackId}`, {
    method: 'DELETE',
    data: {},
  })
}

/**
 * Returns exclusive competitor list for connected accounts
 * @param appTrackId app track id
 * @param countryCode country code
 * @returns {Promise<any>}
 */
export function getExclusiveCompetitors(appTrackId, countryCode) {
  return makeRequest(`/datascience/competitor/app/${appTrackId}?country=${countryCode}`, {
    method: 'GET',
  })
}

/**
 * Completes onboarding process for a new user.
 * @param {object} payload - Contains user, app, keywords, competitors and countryCode information.
 * @param {string} payload.firstName - The first name of the user.
 * @param {string} payload.lastName - The last name of the user.
 * @param {string} payload.company - The company name of the user.
 * @param {string} payload.jobFunction - The job title of the user.
 * @param {string} payload.trackId - The ID of the current app.
 * @param {Array.<string|number>} payload.competitorIds - An array that includes the ID list of the competitors.
 * @param {Array.<string>} payload.keywords - An array that includes keywords related to the app.
 * @param {string} payload.countryCode - The country code of the user's location.
 * @returns {Promise<any>} Returns a promise that resolves to the result of the onboarding completion.
 */
export function completeOnboarding({ firstName, lastName, company, jobFunction, trackId, competitorIds, keywords, countryCode }) {
  return makeRequest(`/account/app/onboarding`, {
    method: 'POST',
    data: {
      firstName,
      lastName,
      company,
      jobFunction,
      trackId,
      competitorIds,
      keywords,
      countryCode,
    },
  })
}

export function getKeywordTrackStatus({ trackId, countryCode, keywords }) {
  return makeRequest(`/account/app/${trackId}/country/${countryCode}/tracked-keywords`, {
    method: 'POST',
    data: keywords,
  })
}
